/**
 * Created by Aliaksandr_Litskevic on 10/15/2015.
 */
import Application from './js/Application.jsx';
import Plugin from './js/Plugin.jsx';

// the singleton application instance
let APP = null;

/**
 * An Application API.
 *
 * @see ./Application.js
 * @see ./Plugin.js
 */
export default {

    applicationInstance: function () {

        if (!APP) {

            throw new Error('No Application instance created yet.');

        }
        return APP;
    }
    ,
    createApplication(config) {


        if (APP) {

            throw new Error('Application instance has been already created.');

        }

        return APP = new Application(config);
    }
    ,
    Plugin
}